var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 130",
    style: {
      enableBackground: "new 0 0 170 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#32324E;}\n\t.st2{fill:none;stroke:#32324E;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#32324E;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#32324E;stroke-width:4;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#32324E;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.46,86c-2.21,0-4-1.79-4-4V37c0-2.21,1.79-4,4-4h34c2.21,0,4,1.79,4,4v45c0,2.21-1.79,4-4,4H109.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.46,35c1.1,0,2,0.9,2,2v45c0,1.1-0.9,2-2,2h-34c-1.1,0-2-0.9-2-2V37c0-1.1,0.9-2,2-2H143.46 M143.46,31 h-34c-3.31,0-6,2.69-6,6v45c0,3.31,2.69,6,6,6h34c3.31,0,6-2.69,6-6V37C149.46,33.69,146.77,31,143.46,31L143.46,31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.46,86c-2.21,0-4-1.79-4-4V37c0-2.21,1.79-4,4-4h34c2.21,0,4,1.79,4,4v45c0,2.21-1.79,4-4,4H67.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.46,35c1.1,0,2,0.9,2,2v45c0,1.1-0.9,2-2,2h-34c-1.1,0-2-0.9-2-2V37c0-1.1,0.9-2,2-2H101.46 M101.46,31 h-34c-3.31,0-6,2.69-6,6v45c0,3.31,2.69,6,6,6h34c3.31,0,6-2.69,6-6V37C107.46,33.69,104.77,31,101.46,31L101.46,31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 112.54,
    y1: 45,
    x2: 139.46,
    y2: 45
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 112.54,
    y1: 53,
    x2: 134.46,
    y2: 53
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 112.54,
    y1: 61,
    x2: 128.46,
    y2: 61
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 112.54,
    y1: 69,
    x2: 118.46,
    y2: 69
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 98.46,
    y1: 45,
    x2: 71.54,
    y2: 45
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 98.46,
    y1: 53,
    x2: 76.54,
    y2: 53
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 98.46,
    y1: 61,
    x2: 82.54,
    y2: 61
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 98.46,
    y1: 69,
    x2: 92.54,
    y2: 69
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.46,13c3.86,0,7,3.14,7,7s-3.14,7-7,7s-7-3.14-7-7S47.6,13,51.46,13 M51.46,9c-6.08,0-11,4.92-11,11 s4.92,11,11,11s11-4.92,11-11S57.53,9,51.46,9L51.46,9z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 64.2,
    y1: 110.1,
    x2: 53.5,
    y2: 96.76
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.89,120V91.7c0-5.9,4.8-10.7,10.7-10.7h7.3c1.1,0,2-0.9,2-2v-7h12v7c0,1.1,0.9,2,2,2h7.3 c5.9,0,10.7,4.8,10.7,10.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.03,97.06c2.08,1.72,3.27,4.25,3.27,6.94s-1.19,5.22-3.27,6.94c-0.46,0.38-0.73,0.95-0.73,1.54V121h-31 v-9.47c0-0.51-0.19-1-0.54-1.37c-1.58-1.68-2.46-3.87-2.46-6.16s0.87-4.48,2.46-6.16"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.89,73c-8.79,0-15.95-7.15-15.95-15.95v-9.48c7.55-1.9,12.79-4.42,22.06-14.16 c2.49,3.95,6.85,8.51,9.83,11.43v12.21C52.84,65.85,45.69,73,36.89,73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.75,36.55c2.42,3.29,5.61,6.67,8.09,9.13v11.37c0,7.69-6.26,13.95-13.95,13.95s-13.95-6.26-13.95-13.95 v-7.94C29.62,47.28,34.75,44.63,42.75,36.55 M43.46,30c-11,12-16,14-24.51,16v11.05c0,9.91,8.04,17.95,17.95,17.95 c9.91,0,17.95-8.04,17.95-17.95V44C51.58,40.85,45.18,34.28,43.46,30L43.46,30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54.38,58.99L54.55,59c0,0,0,0,0.01,0c2.8,0,5.04-2.24,5.04-5c0-2.76-2.24-5-5-5l-0.29,0.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M19.51,49.01L19.35,49c0,0,0,0-0.01,0c-2.8,0-5.04,2.24-5.04,5c0,2.76,2.24,5,5,5l0.29-0.02"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.25,116c-2.73,0-4.95-2.22-4.95-4.95V85.26h9.9v25.79C73.2,113.78,70.98,116,68.25,116z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.2,87.26v23.79c0,1.63-1.32,2.95-2.95,2.95s-2.95-1.32-2.95-2.95V87.26H71.2 M75.2,83.26H61.3v27.79 c0,3.84,3.11,6.95,6.95,6.95s6.95-3.11,6.95-6.95V83.26L75.2,83.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.3,85.89v-3.79c0-3.37,2.74-6.11,6.11-6.11h13.05v3.79c0,3.37-2.74,6.11-6.11,6.11H63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.46,78v1.79c0,2.26-1.84,4.11-4.11,4.11H65.3v-1.79c0-2.26,1.84-4.11,4.11-4.11H80.46 M84.46,74H69.41 c-4.48,0-8.11,3.63-8.11,8.11v5.79h15.05c4.48,0,8.11-3.63,8.11-8.11V74L84.46,74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.4,56.44c-3,0-5.44-2.44-5.44-5.44s2.44-5.44,5.44-5.44h2.12c3,0,5.44,2.44,5.44,5.44 s-2.44,5.44-5.44,5.44H45.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.52,47.56c1.9,0,3.44,1.54,3.44,3.44s-1.54,3.44-3.44,3.44H45.4c-1.9,0-3.44-1.54-3.44-3.44 s1.54-3.44,3.44-3.44H47.52 M47.52,43.56H45.4c-4.11,0-7.44,3.33-7.44,7.44s3.33,7.44,7.44,7.44h2.12c4.11,0,7.44-3.33,7.44-7.44 S51.63,43.56,47.52,43.56L47.52,43.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,56.44c-3,0-5.44-2.44-5.44-5.44s2.44-5.44,5.44-5.44h2.12c3,0,5.44,2.44,5.44,5.44 s-2.44,5.44-5.44,5.44H26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.52,47.56c1.9,0,3.44,1.54,3.44,3.44s-1.54,3.44-3.44,3.44H26.4c-1.9,0-3.44-1.54-3.44-3.44 s1.54-3.44,3.44-3.44H28.52 M28.52,43.56H26.4c-4.11,0-7.44,3.33-7.44,7.44s3.33,7.44,7.44,7.44h2.12c4.11,0,7.44-3.33,7.44-7.44 S32.63,43.56,28.52,43.56L28.52,43.56z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.89,41c0-11.03,8.97-20,20-20s20,8.97,20,20v6.53c-4.84-2.93-8.84-7.16-11.47-12.16 c-0.32-0.61-0.94-1.02-1.63-1.07c-0.05,0-0.1,0-0.14,0c-0.64,0-1.24,0.31-1.62,0.83C36.21,43.19,26.81,48,16.89,48V41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.89,23c9.93,0,18,8.07,18,18v2.71c-3.17-2.52-5.81-5.68-7.7-9.27c-0.64-1.23-1.88-2.03-3.26-2.13 c-0.1-0.01-0.19-0.01-0.29-0.01c-1.28,0-2.49,0.61-3.24,1.66c-5.05,7-12.99,11.38-21.52,11.97V41C18.89,31.07,26.97,23,36.89,23  M36.89,19c-12.15,0-22,9.85-22,22v8.93c0.66,0.04,1.33,0.07,2,0.07c11.02,0,20.77-5.4,26.76-13.7 c3.34,6.37,8.71,11.5,15.24,14.57V41C58.89,28.85,49.04,19,36.89,19L36.89,19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 34.46,
    y1: 50,
    x2: 39.46,
    y2: 50
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "24.98,94.85 25.63,89.81 21.1,87.69 24.14,81 29.38,81 33.7,101.92  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.75,83l2.86,13.83L27.11,94l0.32-2.48l0.37-2.9l-2.65-1.24l-1.41-0.66L25.43,83H27.75 M31.01,79h-8.15 l-4.39,9.67l5,2.33l-0.61,4.7L36.79,107L31.01,79L31.01,79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "44.33,81 49.57,81 52.62,87.72 48.35,89.8 48.77,94.81 40.01,101.92  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.28,83l1.72,3.78l-1.29,0.63l-2.46,1.2l0.23,2.73l0.22,2.59l-3.59,2.91L45.96,83H48.28 M50.85,79H42.7 l-5.79,28l13.94-11.3L50.46,91l4.79-2.33L50.85,79L50.85,79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 32.46,
    y1: 90,
    x2: 40.46,
    y2: 90
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.06,94.93c-0.13,0-0.38-0.03-0.59-0.24L120.5,81.72c-0.32-0.32-0.32-0.85,0-1.17l16.51-16.51 c0.21-0.21,0.46-0.24,0.59-0.24s0.38,0.03,0.59,0.24l12.97,12.97c0.32,0.32,0.32,0.85,0,1.17l-16.51,16.51 C134.44,94.9,134.19,94.93,134.06,94.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.42,65.46L138.42,65.46L138.42,65.46 M137.6,66.29l11.31,11.31l-14.85,14.85l-11.31-11.31L137.6,66.29  M137.6,61.8c-0.72,0-1.45,0.28-2,0.83l-16.51,16.51c-1.1,1.1-1.1,2.9,0,4l12.97,12.97c0.55,0.55,1.28,0.83,2,0.83 c0.72,0,1.45-0.28,2-0.83l16.51-16.51c1.1-1.1,1.1-2.9,0-4L139.6,62.63C139.04,62.08,138.32,61.8,137.6,61.8L137.6,61.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "112.85,85.38 118.5,79.72 136.18,97.4 130.52,103.06  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.92,81.14L119.92,81.14L119.92,81.14 M118.5,82.55l14.85,14.85l-2.83,2.83l-14.85-14.85L118.5,82.55  M118.5,77.72c-0.51,0-1.02,0.2-1.41,0.59l-5.66,5.66c-0.78,0.78-0.78,2.05,0,2.83l17.68,17.68c0.39,0.39,0.9,0.59,1.41,0.59 c0.51,0,1.02-0.2,1.41-0.59l5.66-5.66c0.78-0.78,0.78-2.05,0-2.83l-17.68-17.68C119.53,77.92,119.02,77.72,118.5,77.72 L118.5,77.72z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "136.18,62.04 141.84,56.39 159.52,74.06 153.86,79.72  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.25,57.8L143.25,57.8L143.25,57.8 M141.84,59.22l14.85,14.85l-2.83,2.83l-14.85-14.85L141.84,59.22  M141.84,54.39c-0.51,0-1.02,0.2-1.41,0.59l-5.66,5.66c-0.78,0.78-0.78,2.05,0,2.83l17.68,17.68c0.39,0.39,0.9,0.59,1.41,0.59 s1.02-0.2,1.41-0.59l5.66-5.66c0.78-0.78,0.78-2.05,0-2.83l-17.68-17.68C142.86,54.58,142.35,54.39,141.84,54.39L141.84,54.39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155.98,106.23c-1.57,0-3.05-0.6-4.18-1.7l-12.21-14.78l5.91-5.91l14.78,12.21c2.28,2.34,2.26,6.1-0.06,8.42 C159.09,105.6,157.58,106.23,155.98,106.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.63,86.54l13.29,10.98c1.45,1.57,1.41,4.02-0.11,5.54c-0.76,0.76-1.76,1.17-2.83,1.17 c-1.02,0-1.97-0.38-2.71-1.06l-10.98-13.29L145.63,86.54 M145.37,81.14l-8.49,8.49l13.43,16.26c1.56,1.56,3.61,2.34,5.66,2.34 s4.09-0.78,5.66-2.34v0c3.12-3.12,3.12-8.19,0-11.31L145.37,81.14L145.37,81.14z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 5,
    y1: 121,
    x2: 165,
    y2: 121
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaw);
export default __webpack_public_path__ + "static/media/icon_law.99f49895ae2ded9b6761ce80c48ef53e.svg";
export { ForwardRef as ReactComponent };